/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Customer_Contract_PeriodsInputs */



/**
* | output |
* | --- |
* | "Term length (billing periods)" |
*
* @param {Partner_Add_Customer_Contract_PeriodsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_customer_contract_periods = /** @type {((inputs?: Partner_Add_Customer_Contract_PeriodsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Customer_Contract_PeriodsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Laufzeit (Abrechnungsperioden)")
	return /** @type {LocalizedString} */ ("Term length (billing periods)")
});